import { createFileRoute } from '@tanstack/react-router'
import CompanyCreate from '../components/company-create/CompanyCreate'

export const Route = createFileRoute('/_a/companies/create')({
  component: CompanyCreate,
})
